/* eslint-disable */
export default {
  removeMeetingWarning:
    'Die Planungsfunktion wurde eingestellt. Verwenden Sie {app}, um Ihre Videobesprechungen zu planen.',
  scheduleMeetingTips:
    'Beachten Sie, dass wir Besprechungen aus dieser App entfernt haben. Zur Verwendung von Besprechungen empfehlen wir {app}.',
  migrateToPluginAlert:
    'Hinweis: Diese App funktioniert nicht mit Outlook Version 2016 und niedriger und Internet Explorer 11. Aktualisieren Sie Outlook oder wechseln Sie zu Microsoft Edge. Alternativ können Sie auch zu {app} wechseln.',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
